module.exports = __webpack_public_path__ + "img/1.5dc4b716.png";